import SchemaOrg from '@/core/components/SchemaOrg/SchemaOrg';

export default SchemaOrg;
